// This file was auto-generated using scripts/generate-icons.js
import type { JSX } from 'preact';

export type FlashcardIconProps = JSX.SVGAttributes<SVGSVGElement>;

/**
 * Icon generated from flashcard.svg
 */
export default function FlashcardIcon(props: FlashcardIconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      aria-hidden="true"
      viewBox="0 0 16 16"
      data-component="FlashcardIcon"
      {...props}
    >
      <g fill-rule="evenodd">
        <path fill="none" d="M0 0h16v16H0z" />
        <path fill="currentColor" d="M0 4.5a.5.5 0 0 1 1 0v7a.5.5 0 0 1-1 0z" />
        <path
          fill="currentColor"
          d="M0 11.5a.5.5 0 0 0 1 0v-7a.5.5 0 0 0-1 0zM15 4.5a.5.5 0 0 1 1 0v7a.5.5 0 0 1-1 0z"
        />
        <path
          fill="currentColor"
          d="M15 11.5a.5.5 0 0 0 1 0v-7a.5.5 0 0 0-1 0zM2 5a2 2 0 0 1 2-2h8a2 2 0 0 1 2 2v6a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2zm10 .5a.5.5 0 0 0-.5-.5h-7a.5.5 0 0 0-.5.5v5a.5.5 0 0 0 .5.5h7a.5.5 0 0 0 .5-.5z"
        />
      </g>
    </svg>
  );
}
